<template>
    <CButton
        :block="block"
        :color="color"
        :disabled="disabled"
        :type="type"
        :title="title"
        class="ml-2 button shadow d-flex add-button"
        @click="$emit('click')"
    >
        <span class="button__icon">
            <CIcon :content="$options.icons.cilPlus" />
        </span>
        <span class="button__text">
            <slot>
                {{ $t("add") }}
            </slot>
        </span>
    </CButton>
</template>

<script>
import { cilPlus} from "@coreui/icons";
export default {
    name: "ButtonAdd",
    icons: {
        cilPlus
    },
    props: {
        block: {
            type: Boolean,
            default: false,
        },
        color: {
            default: "success",
            type: String,
        },
        disabled: Boolean,
        type: String,
        title: {
            type:String
        },
    },
};
</script>
<style lang="scss">
</style>